<script setup lang="ts">
  import { useTemplateRef } from 'vue'
  import { fmt } from '@/functions'
  import { useProductMultiplierList } from '@/models/product-multiplier'
  import ModalEdit from '@/views/app/product/multiplier/edit/modal-edit.vue'

  const { getData, productMultipliers, pagination } = useProductMultiplierList()

  getData({
    page: 1,
    per_page: 10,
    multiplier: 'unset',
  })

  const refModalEdit = useTemplateRef('refModalEdit')
  const edited = (newMultiplier: ProductMultiplier) => {
    productMultipliers.value = productMultipliers.value.filter((pm) => pm.id !== newMultiplier.id)
  }
</script>

<template>
  <app-card
    icon="i-far-percent"
    title="Multiplier Belum Diset">
    <app-table>
      <thead>
        <tr>
          <th class="w-px text-right">
            #
          </th>
          <th class="text-left">
            Grup
          </th>
          <th class="text-left">
            Supplier
          </th>
          <th class="text-left">
            Tanggal Daftar
          </th>
          <th class="w-px">
            Produk
          </th>
          <th class="w-px"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(productMultiplier, i) in productMultipliers"
          :key="productMultiplier.id">
          <td class="text-right">
            {{ (pagination?.from ?? 0)+ i }}.
          </td>
          <td>{{ productMultiplier.group?.name }}</td>
          <td>{{ productMultiplier.supplier?.name }}</td>
          <td :title="fmt.date(productMultiplier.created_at)">
            {{ fmt.dateRelative(productMultiplier.created_at) }}
          </td>
          <td class="text-right">
            <app-button
              class="clickable"
              :to="{
                name: 'product list',
                query: {
                  multiplier: productMultiplier.id,
                }
              }">
              {{ fmt.number(productMultiplier.products_count) }}
            </app-button>
          </td>
          <td class="buttons">
            <app-button
              title="Edit Grup Produk"
              @click="refModalEdit?.open(productMultiplier)">
              <fa-icon icon="i-far-pen-to-square" />
            </app-button>
          </td>
        </tr>
        <tr v-if="productMultipliers.length === 0">
          <td
            colspan="9"
            class="h-48 text-center">
            <fa-icon
              class="text-6xl mb-4"
              icon="i-fat-thumbs-up" />
            <div class="text-2xl font-bold mb-2">
              All set!
            </div>
            <div class="text-gray-500">
              Semua produk siap dijual
            </div>
          </td>
        </tr>
        <tr v-if="(pagination?.total ?? 0) > (pagination?.per_page ?? 0)">
          <td colspan="9">
            <app-button
              class="btn-link"
              :to="{name: 'product price multiplier'}">
              Lihat semua ({{ pagination?.total ?? 0 }} multiplier)
            </app-button>
          </td>
        </tr>
      </tbody>
    </app-table>

    <modal-edit
      ref="refModalEdit"
      @edited="edited" />
  </app-card>
</template>
